import React, { FC, useRef } from 'react';
import { graphql, Link } from 'gatsby';

import useScreenRecognition from 'hooks/useScreenRecognition';
import GatsbyImage from 'common/GatsbyImage';
import DangerouslySetInnerHtml from 'common/DangerouslySetInnerHtml';
import Button from 'common/Button';

import { IPropsHeaderBanner } from './model';

import './HeaderBanner.scss';

const HeaderBanner: FC<IPropsHeaderBanner> = ({
  logo,
  logoMobile,
  logoAlt,
  label,
  title,
  text,
  image,
  imageAlt,
  imageProduct,
  imageProductAlt,
  link,
  bgDecoration,
  bgDecorationAlt,
}) => {
  const { isDesktop } = useScreenRecognition();

  return isDesktop ? (
    <Link
      className="header-banner__button"
      to={link[0].properties.link[0].url}
      aria-label={link[0].properties.ariaLabel}
    >
      <GatsbyImage
        className="header-banner__button-logo"
        objectFit="contain"
        image={logo}
        alt={logoAlt}
      />
      <DangerouslySetInnerHtml
        html={link[0].properties.label}
        className="header-banner__button-text"
      />
      <DangerouslySetInnerHtml
        html={label}
        className="header-banner__label header-banner__button-label"
      />
    </Link>
  ) : (
    <div className="header-banner">
      <div className="header-banner__content content">
        <GatsbyImage
          className="content__logo"
          objectFit="contain"
          image={logoMobile}
          alt={logoAlt}
        />
        <DangerouslySetInnerHtml html={title} className="content__title" />
        <div className="content__text-wrapper">
          <DangerouslySetInnerHtml html={text} className="content__text" />
          <GatsbyImage
            className="content__image"
            objectFit="contain"
            image={image}
            alt={imageAlt}
          />
        </div>
        <GatsbyImage
          className="content__image-product"
          image={imageProduct}
          alt={imageProductAlt}
          objectFit="contain"
        />
        <DangerouslySetInnerHtml html={label} className="header-banner__label content__label" />
        <GatsbyImage
          className="content__decoration"
          objectFit="contain"
          image={bgDecoration}
          alt={bgDecorationAlt}
        />
      </div>
      <div className="header-banner__btn-wrapper">
        <Button
          link={link[0].properties.link[0].url}
          ariaLabel={link[0].properties.ariaLabel}
          className="header-banner__btn"
          textAlign="center"
        >
          {link[0].properties.label}
        </Button>
      </div>
    </div>
  );
};

export const query = graphql`
  fragment FragmentHeaderBanner on THeaderBanner {
    properties {
      logo {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 77, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      logoMobile {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 156, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      logoAlt
      label
      title
      text
      image {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 60, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      imageAlt
      imageProduct {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 148, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      imageProductAlt
      link {
        ...FragmentButton
      }
      bgDecoration {
        ...FragmentGatsbyProps
        gatsbyImage {
          childImageSharp {
            fluid(maxWidth: 200, quality: 90) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
      bgDecorationAlt
    }
  }
`;

export default HeaderBanner;
